import axios from 'axios';

let proto = "http"
let ip = "192.168.1.228"
let port = "8080"
export default axios.create({
  baseURL: `${proto}://${ip}:${port}/`
});